"use client";

import React from "react";
import { ProcedureSectionData } from "@/lib/procedure-sections/types";
import { CardsGridSection } from "./CardsGridSection";
import { SplitMediaSection } from "./SplitMediaSection";
import { ProcessStepsSection } from "./ProcessStepsSection";
import { QuoteHighlightSection } from "./QuoteHighlightSection";
import { RichTextSection } from "./RichTextSection";

export function ProcedureSectionRenderer({ 
  sections, 
  isPreview = false 
}: { 
  sections: ProcedureSectionData[]; 
  isPreview?: boolean;
}) {
  if (!sections || sections.length === 0) return null;

  return (
    <div className="w-full divide-y divide-brand-gray-light/40">
      {sections.map((section, idx) => {
        const isAlternateBg = idx % 2 === 1;
        const bgClass = 
          section.bgStyle === "warm" ? "bg-brand-peach/15" :
          section.bgStyle === "accent" ? "bg-brand-orange-deep/5" :
          isAlternateBg ? "bg-[#FAF9F6]" : "bg-white";

        return (
          <section
            key={section.id || `section-${idx}`}
            id={section.id || `section-${idx}`}
            className={`w-full relative ${bgClass} ${
              isPreview ? "py-10 sm:py-14" : "py-10 md:py-16"
            }`}
          >
            <div className={`w-full ${
              isPreview ? "px-4 sm:px-8 lg:px-12 max-w-6xl mx-auto" : "px-6 md:px-12 xl:px-[170px]"
            }`}>
              {section.type === "cards_grid" && (
                <CardsGridSection section={section} index={idx} />
              )}
              {section.type === "split_media" && (
                <SplitMediaSection section={section} index={idx} />
              )}
              {section.type === "process_steps" && (
                <ProcessStepsSection section={section} index={idx} />
              )}
              {section.type === "quote_highlight" && (
                <QuoteHighlightSection section={section} index={idx} />
              )}
              {section.type === "rich_text" && (
                <RichTextSection section={section} index={idx} />
              )}
            </div>
          </section>
        );
      })}
    </div>
  );
}
